import { Container, Row, Col, Nav, Tab} from "react-bootstrap"
import { ProjectsTimeline } from "./ProjectsTimeline"
import projImgICNF from "../assets/img/icnf-proj.png"
import projImgOneX from "../assets/img/onex-proj.png"
import projImg3CA from "../assets/img/3CA-proj.png"
import projImgUniAI from "../assets/img/ai_uni-proj.png"
import projImgUniCurso from "../assets/img/ubi-proj.png"

export const Projects = () => {
    const work_projects = [
        {
            title: "ICNF",
            company: "Babel S.A.",
            role: "Junior Developer",
            technologies: "OutSystems, JavaScript, CSS",
            description: "Frontend development and UI design for a Portuguese government agency, with intensive OutSystems training in a production environment.",
            timePeriod: "2021 - 2022",
            imgUrl: projImgICNF
        },
        {
            title: "One-X",
            company: "SmartDev · Code495",
            role: "Full Stack Developer",
            technologies: "Laravel, jQuery, MySQL",
            description: "Built an automated ticketing platform for Altice USA on behalf of Excell Communications, covering field incidents, finance and inventory. Initiated an AI allocation system for field technicians, later continued as a master's internship project.",
            timePeriod: "2022 - 2024",
            imgUrl: projImgOneX
        }
    ]

    const work_projects2 = [
        {
            title: "StarMountain",
            role: "Software Engineer",
            technologies: "Golang, NATS, MongoDB, Node.js, Redis, Docker",
            description: "Full-stack engineer on a medicinal cannabis traceability SaaS — from API design and real IoT integration to CRM/SRM integrations, co-driving technical decisions alongside the lead architect.",
            timePeriod: "2024 - 2025",
            imgUrl: projImgOneX,
            link: "https://www.starmountain.pt/"
        },
        {
            title: "RUI",
            company: "EVO Soluções Financeiras",
            role: "Full Stack Developer",
            technologies: "C#, .NET, Vue 3, TypeScript, Docker, SQL Server",
            description: "Full-stack development of RUI, a financial platform for lawyers and OAB (Ordem dos Advogados do Brasil) administrators to manage annual fee billing and debt collection across Brazilian states.",
            timePeriod: "2025 - Present",
            imgUrl: projImgOneX,
            link: "https://rui.adv.br/"
        }
    ]

    const uni_projects = [
        {
            title: "Web Computing Degree",
            technologies: null,
            description: "Bachelor's in Web Computing at Universidade da Beira Interior (UBI), focused on full-stack web development and the intersection between software and interface design.",
            timePeriod: "2018 - 2021",
            imgUrl: projImgUniCurso
        }, 
        {
            title: "3CA Management System and Blog",
            technologies: "PHP, HTML5, CSS",
            description: "First solo project — a room management system for UBI's (Universidade da Beira Interior) 3CA space, covering scheduling, requests and a blog. Adopted and used by the university.",
            timePeriod: "2021",
            imgUrl: projImg3CA
        }
    ]

    const personal_projects = [
        {
            title: "Bright Lisbon Agency",
            technologies: "React, Node.js, MongoDB",
            description: "Built a full-stack website and backoffice for Portugal's first Junior Enterprise in Communications — featuring secure authentication and a content management panel that allows the team to independently manage all site content.",
            timePeriod: "2025",
            imgUrl: projImgOneX,
            link: "https://brightlxagency.com/"
        }
    ]

    const uni_projects2 = [
        {
            title: "Computer Science and Engineering MSc",
            technologies: null,
            description: "Master's in Computer Science and Engineering at Universidade da Beira Interior (UBI), deepening expertise in software architecture, systems and applied AI.",
            timePeriod: "2021 - 2024",
            imgUrl: projImgUniCurso
        },
        {
            title: "Process Automation using Artificial Intelligence",
            technologies: "Python, Machine Learning",
            description: "Master's internship project in partnership with Excell Communications — trained an ML model on real ticket data to allocate field technicians by competency, task type and geographic zone.",
            timePeriod: "2024",
            imgUrl: projImgUniAI
        }
    ]
    
    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col>
                        <h2>Experience</h2>
                        <p>Here you can find my developing experience, from professional Work to my University Journey and Personal Projects.</p>
                        <Tab.Container id="projects-tabs" defaultActiveKey="first-project">
                            <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                <Nav.Item>
                                    <Nav.Link eventKey="first-project">Work</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second-project">University</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third-project">Personal</Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content>
                                <Tab.Pane eventKey="first-project">
                                <Row>
                                    <ProjectsTimeline projectsArray={work_projects} moduleNumber="1"/>
                                    <ProjectsTimeline projectsArray={work_projects2} moduleNumber="2"/>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second-project">
                                <Row>
                                    <ProjectsTimeline projectsArray={uni_projects} moduleNumber="1"/>
                                    <ProjectsTimeline projectsArray={uni_projects2} moduleNumber="2"/>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="third-project">
                                <Row>
                                    <ProjectsTimeline projectsArray={personal_projects} moduleNumber="1"/>
                                </Row>
                            </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}